import React from 'react';
import {
    Card,
    ExamTable,
    ExamType,
    MappedExamApplicationStatuses,
} from 'components';
import {
    ExamApplicationStatus,
    ExamStatus,
    IApplicantExam,
    ExamReviewStatus,
} from '../../api/ApiClient';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Color, ColorStatus } from '_helpers';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';
import query from '../../helpers/const/query';

const ExamApplicationsContainer = ({
    fetchExamApplications, setErrorHandler, examApplicationsList, apiError, onPush,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await fetchExamApplications({ examReviewStatus: ExamReviewStatus.All });
            setProcessing(false);
        };

        fetch();
    }, []);

    const handleChooseExam = (id: string) => {
        onPush(`/exam/${id}?from=${query.FROM.APPLICATIONS}`);
    };

    const notReadyForOnlineExam = (app: IApplicantExam) => {
        const readyForOnlineExam = localStorage.getItem('readyForOnlineExam');
        return !readyForOnlineExam && app.examType === ExamType.Online && app.examApplicationStatus === ExamApplicationStatus.Paid;
    };

    const checkApplicantStatus = (app: IApplicantExam) => {
        if (notReadyForOnlineExam(app)) {
            return new ColorStatus(Color.Orange, 'Пройти проверку системы');
        }

        return statuses[app.examApplicationStatus || ''];
    };

    const getFormatTableRows = (examApplicationsListItem: IApplicantExam) => ({
        ...examApplicationsListItem,
        id: examApplicationsListItem.examId,
        name: examApplicationsListItem.qualificationTitle,
        status: checkApplicantStatus(examApplicationsListItem),
    });

    const examApplications = (examApplicationsList && examApplicationsList.items) || [];
    const tableRows = examApplications.map(getFormatTableRows);

    return (
        <Card
          withoutPadding
          title="Заявки на экзамены"
          category="Список поданных заявок на экзамены"
          apiError={apiError}
          showLoader={processing}
        >
            <ExamTable
              header={HEADER}
              tableRows={tableRows}
              onChooseExam={handleChooseExam}
              placeholderTitle="Нет поданных заявок"
              placeholderText="Здесь будут отображаться все Ваши заявки на экзамены"
              placeholderButtonText="Выбрать экзамен"
              onClickPlaceholderButton={() => onPush('/exam-timetables')}
            />
        </Card>
    );
};

const HEADER = [
    'Дата и время',
    'Квалификация',
    'Тип',
    'Статус',
];

const statuses = {
    ...MappedExamApplicationStatuses,
    [ExamStatus.IsApplying as string]: new ColorStatus(Color.Success, 'Идет запись'),
    [ExamStatus.ApplyingFinished as string]: new ColorStatus(Color.Orange, 'Запись завершена'),
    [ExamApplicationStatus.PaymentRequired as string]: new ColorStatus(Color.Orange, 'Требуется оплата'),
    [ExamApplicationStatus.Paid as string]: new ColorStatus(Color.Default, 'Вы записаны'),
};


const mapState = (state: IRootState) => ({
    examApplicationsList: state.examApplications.examApplicationsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    fetchExamApplications: dispatch.examApplications.fetchExamApplicationsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    onPush: (key: string) => dispatch(push(key)),
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ExamApplicationsContainer);
